const getMultipleValuesFromString = (str: string): string[] => str.split(/;|,| /g).filter((name) => name.length);
export default getMultipleValuesFromString;
